import React, { useState, useEffect, useContext } from 'react'
import { Form, Formik } from 'formik'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { FiCheck, FiPlus } from 'react-icons/fi'
import { toast } from 'react-toastify'

import Card from '~/components/Card'
import { Button, Textbox } from '~/components/Form'
import Spinner from '~/components/Spinner'
import Table from '~/components/Table'

import { api, authHeaders } from '~/services/api'

import { Container } from './styles'

import Yup from '~/services/yup'
import { TipContext } from '~/contexts/TipContext'
import { loadTips } from '~/util/tip'

const baseInitialValues = {
    cargo: ''
}

export default function () {
    const { setCodigo, tips } = useContext(TipContext)

    const [cargos, setCargos] = useState(null)
    const [showCadastro, setShowCadastro] = useState(false)
    const [initialValues, setInitialValues] = useState(baseInitialValues)
    const [emEdicao, setEmEdicao] = useState(null)

    async function loadCargos() {
        setCargos(null)
		
        const response = await api.get('eleicao/cargos', authHeaders())

        setCargos(response)
    }

    async function handleDelete(item) {
        try {
            await api.delete(`eleicao/cargos/${item.id}`, authHeaders())

            toast.success('Cargo excluído.')

            loadCargos()
        } catch(e) {
            toast.error(e.msg)
        }
    }

    async function handleSubmit(values) {
        try {
            if(emEdicao) {
                await api.put(`eleicao/cargos/${emEdicao.id}`, values, authHeaders())	

                toast.success('Cargo atualizado.')
            } else {
                await api.post('eleicao/cargos', values, authHeaders())

                toast.success('Cargo cadastrado.')
            }

            setShowCadastro(false)

            setEmEdicao(null)

            setInitialValues(baseInitialValues)

            loadCargos()
        } catch(e) {
            toast.error(e.msg)
        }
    }

    async function handlePrepareEdit(item) {
        setEmEdicao(item)

        setShowCadastro(true)

        setInitialValues({
            cargo: item.descricao
        })
    }

    useEffect(() => {
        loadCargos()

        loadTips(setCodigo, 'form_cargos_eleitorais')
    }, [])

    return (
        <Container>
            <main>
                <Card>
                    <h1>Cargos eleitorais</h1>

                    {showCadastro ? (
                        <Formik
                            onSubmit={handleSubmit}
                            initialValues={initialValues}
                            enableReinitialize
                            validationSchema={Yup.object({
                                cargo: Yup.string().required('Informe o nome do cargo.')
                            })}
                        >
                            {() => (
                                <Form>
                                    <p style={{ margin: 8, gridColumn: '1/span 3' }}>{tips?.formulario}</p>

                                    <div>
                                        <Textbox 
                                            name="cargo"
                                            label="Cargo"
                                        />

                                        <Button className="transparent" type="submit">
                                            {emEdicao ? 'Salvar alterações' : 'Cadastrar'}
                                            <FiCheck size={17} />
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        <Button className="transparent" onClick={() => { setShowCadastro(true) }}>
                            Cadastrar novo
                            <FiPlus size={16} />
                        </Button>
                    )}

                    {cargos ? (
                        <Table 
                            headers={[
                                { name: 'descricao', value: 'Cargo' }
                            ]}
                            data={cargos}
                            filterable
                            actions={[
                                {
                                    action: handlePrepareEdit,
                                    name: 'Editar',
                                    icon: FaEdit,
                                    iconSize: 15
                                },
                                {
                                    action: handleDelete,
                                    name: 'Excluir',
                                    icon: FaTrash,
                                    iconSize: 13,
                                    confirmation: 'Deseja realmente excluir este cargo?'
                                }
                            ]}
                        />
                    ) : (
                        <Spinner />
                    )}
                </Card>
            </main>
        </Container>
    )
}
